import { useaxios } from "../../../../utils/useaxios";
export default (text) => employDispatch => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // setloading(true);
    console.log(text);
    useaxios('employ/search.php', { text }).then((res) => {
        console.log(res);
        if (res.status == "ok") {
            employDispatch({ type: 'setsearch', payload: res.employ });
        } else {
            // clear();
        }
        // setloading(false);
    });
}